import { BaseEntityFieldInfos, BaseEntityInfoUtils, EntityFieldInfo } from '@record-it-npm/synchro-common';
import { AppCommonSynchronizationEnvironmentTypes } from '../../AppCommonSynchronizationEnvironment';
import { EntityName } from '../../EntityName';
import { UserGroupSubEntityDto } from './UserGroupSubEntityDto';
export class UserGroupSubEntityInfoUtils {
  private constructor() {}
  public static createBaseFieldInfos(): UserGroupSubEntityFieldInfos {
    return {
      ...BaseEntityInfoUtils.createBaseFieldInfos(),
      ownerUserGroupId: {
        name: 'ownerUserGroupId',
        ref: EntityName.UserGroup
      }
    };
  }
}
export type UserGroupSubEntityFieldInfos = BaseEntityFieldInfos<AppCommonSynchronizationEnvironmentTypes> & {
  ownerUserGroupId: EntityFieldInfo<AppCommonSynchronizationEnvironmentTypes, UserGroupSubEntityDto, 'ownerUserGroupId'>;
};